module.exports = __webpack_public_path__ + "media/images/burger-4f615ee59fcd595f496afe9a2d6c469c.svg";